module.exports = "/365FarmNet/dist/registration.4ad302a413e60f501ae2ce372c4c4eb9.html";